import React from 'react';
const ANALYTICS_SCREEN = {
  src: 'https://cdn.magicpatterns.com/uploads/fgkmBAmEFUQy5Nx7soa2SK/Analytics_-_1260px.png',
  alt: 'Vendoo Analytics screen: date range filter, a Revenue & Profit area chart with total revenue and profit, and a summary of sold items, listed items and average sale price compared with the previous period'
};
export function VendooTabletMock() {
  return <div className="grid place-items-center rounded-2xl bg-surface px-4 py-8 md:px-12 md:py-14" data-id="element-782" data-mp="345rljy3a0h9i">
      <div className="w-full max-w-[720px] rounded-[26px] bg-night p-2.5 shadow-xl md:p-3.5" data-id="element-783" data-mp="394cnc1y6f902">
        <div className="overflow-hidden rounded-[16px] bg-white" data-id="element-784" data-mp="3e3z24ftnkxaz">
          <img src={ANALYTICS_SCREEN.src} alt={ANALYTICS_SCREEN.alt} loading="eager" decoding="async" className="block h-auto w-full" data-id="element-785" data-mp="3e1mb7d5x3cls" />
        </div>
      </div>
    </div>;
}